import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { usePurchaseOfferDetailsModel } from "./purchaseOfferDetailsModel";
import { formatNum } from "@/utils/utils";


export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel()
    const { addDesc, editDesc, lookDesc } = usePurchaseOfferDetailsModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: "数量总计",
            value: typeDesc[mode]?.numAll,
            // value:111,
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "报价金额合计",
            value: formatNum(typeDesc[mode]?.totalAllprice),
            // value:111,
            color: DescriptionColorEnum.red,
            status: true
        },
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}